module.exports = __webpack_public_path__ + "static/img/qp2.3b0d159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qp2.png
// module id = hKj7
// module chunks = 2